import React, { useEffect, useState } from 'react';
import { Timer, Flame } from 'lucide-react';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 12,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-12 bg-white px-6 lg:px-8 border-y border-brand-light" data-id="element-312">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-313">
        <div className="flex-1 w-full flex flex-col items-center md:items-start" data-id="element-314">
          <div className="flex items-center gap-2 mb-3 text-brand-navy font-bold" data-id="element-315">
            <Timer className="w-5 h-5 text-brand-warm" data-id="element-316" />
            <span data-id="element-317">Precio de lanzamiento cierra en:</span>
          </div>
          <div className="flex gap-3 text-3xl font-extrabold text-brand-navy" data-id="element-318">
            <div className="flex flex-col items-center" data-id="element-319">
              <div className="bg-brand-lighter px-4 py-2 rounded-lg border border-brand-light min-w-[70px] text-center" data-id="element-320">
                {formatTime(timeLeft.hours)}
              </div>
              <span className="text-xs text-brand-navy/50 mt-1 uppercase tracking-wider" data-id="element-321">
                Horas
              </span>
            </div>
            <span className="py-2 text-brand-warm" data-id="element-322">:</span>
            <div className="flex flex-col items-center" data-id="element-323">
              <div className="bg-brand-lighter px-4 py-2 rounded-lg border border-brand-light min-w-[70px] text-center" data-id="element-324">
                {formatTime(timeLeft.minutes)}
              </div>
              <span className="text-xs text-brand-navy/50 mt-1 uppercase tracking-wider" data-id="element-325">
                Min
              </span>
            </div>
            <span className="py-2 text-brand-warm" data-id="element-326">:</span>
            <div className="flex flex-col items-center" data-id="element-327">
              <div className="bg-brand-lighter px-4 py-2 rounded-lg border border-brand-light min-w-[70px] text-center text-brand-warm" data-id="element-328">
                {formatTime(timeLeft.seconds)}
              </div>
              <span className="text-xs text-brand-navy/50 mt-1 uppercase tracking-wider" data-id="element-329">
                Seg
              </span>
            </div>
          </div>
          <p className="text-sm text-brand-navy/60 mt-3 font-medium" data-id="element-330">
            Después sube $5.000
          </p>
        </div>

        <div className="flex-1 w-full bg-brand-lighter rounded-2xl p-6 border border-brand-light" data-id="element-331">
          <div className="flex items-center justify-between mb-3" data-id="element-332">
            <div className="flex items-center gap-2 font-bold text-brand-navy" data-id="element-333">
              <Flame className="w-5 h-5 text-brand-warm" data-id="element-334" />
              <span data-id="element-335">Cupos limitados</span>
            </div>
            <span className="font-bold text-brand-warm" data-id="element-336">68% tomados</span>
          </div>
          <div className="h-4 w-full bg-white rounded-full overflow-hidden border border-brand-light" data-id="element-337">
            <div className="h-full bg-brand-warm rounded-full transition-all duration-1000 relative overflow-hidden" style={{
            width: '68%'
          }} data-id="element-338">
              <div className="absolute inset-0 bg-white/20 w-full h-full animate-[shimmer_2s_infinite]" style={{
              transform: 'skewX(-20deg)'
            }} data-id="element-339"></div>
            </div>
          </div>
          <p className="text-xs text-brand-navy/60 mt-3 text-center md:text-left" data-id="element-340">
            Quedan pocos cupos al precio de lanzamiento
          </p>
        </div>
      </div>
    </section>;
}